export default "__VITE_ASSET__CeywyGpX__ 584w";